@if (translationsReady) {
  @if (!hideHeader) {
    <app-new-header></app-new-header>
  }
  <router-outlet></router-outlet>
  @if (!hideHeader) {
    <app-chatbot></app-chatbot>
  }
}